









































import {
	computed,
	defineComponent,
	onMounted,
	PropType,
	ref,
} from '@vue/composition-api';
import ButtonList from '@front-app/components/dropdowns/ButtonList.vue';
import ReactionButtonComponent from '@front-app/components/buttons/ReactionButton.vue';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { ReactionButton } from '@front-app/components/buttons/useReactionButtons';
import { Size } from '@front-app/components/constants';

export default defineComponent({
	components: {
		ButtonList,
		ReactionButtonComponent,
		SimpleDropdown,
	},
	props: {
		reactionButtons: {
			type: Array as PropType<ReactionButton[]>,
			required: true,
		},
	},
	setup(props) {
		const isOpen = ref(false);

		const topReactionButtons = computed(() => {
			// Copy the list of reactions passed as a prop so as not to mutate it
			const activeReactions = props.reactionButtons.map((reactionButton) => reactionButton);
			const reactionsToDisplay = activeReactions.sort((a, b) => b.count - a.count);
			return reactionsToDisplay.slice(0, 3);
		});

		const totalReactionsCount = computed(() => {
			let count = 0;
			props.reactionButtons.forEach((reactionButton) => {
				count += reactionButton.count;
			});
			return count;
		});

		// Responsive view
		const screenWidth = ref(window.innerWidth);
		onMounted(() => {
			window.onresize = () => {
				screenWidth.value = window.innerWidth;
			};
		});
		// eslint-disable-next-line arrow-body-style
		const getReactionButtonSize = () => {
			return screenWidth.value < 810 ? Size.MEDIUM : Size.SMALL;
		};

		return {
			isOpen,
			topReactionButtons,
			totalReactionsCount,
			// Util
			DropdownPosition,
			getReactionButtonSize,
			Size,
		};
	},
});
